module.exports = __webpack_public_path__ + "img/habitaria.202fc92a.png";